export type ObjectType<T = unknown> = {
  [key: string]: T;
};
export type CombinedFilterValuesProps = {
  condition: boolean;
  source: ObjectType;
  newFiled: ObjectType;
};

export const combineFilterValues = ({
  condition,
  source,
  newFiled,
}: CombinedFilterValuesProps) => {
  return condition ? newFiled : source;
};
